// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationProcedureCodes } from './priorAuthorizationProcedureCodes.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis {
    'primaryProcedureCode': PriorAuthorizationProcedureCodes | null;
    'additionalProcedureCodes'?: Array<PriorAuthorizationProcedureCodes>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis>> = [
        {
            "name":     "primaryProcedureCode",
            "baseName": "primaryProcedureCode",
            "type":     "PriorAuthorizationProcedureCodes"
        },
        {
            "name":     "additionalProcedureCodes",
            "baseName": "additionalProcedureCodes",
            "type":     "Array<PriorAuthorizationProcedureCodes>"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis.attributeTypeMap;
    }
}
